import type { CustomFieldDto } from '@performance-crm/shared';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select } from '@/components/ui/select';

/** Un control por campo personalizado según su tipo; los valores viajan siempre como texto. */
export function CustomFieldInputs({
  fields,
  values,
  onChange,
  errors,
  idPrefix = 'cf',
}: {
  fields: CustomFieldDto[];
  values: Record<string, string>;
  onChange: (key: string, value: string) => void;
  errors?: Record<string, string>;
  idPrefix?: string;
}) {
  return (
    <>
      {fields.map((f) => {
        const id = `${idPrefix}-${f.key}`;
        const value = values[f.key] ?? '';
        const label = f.required ? `${f.label} *` : f.label;
        return (
          <div key={f.key} className="space-y-1" data-testid={`custom-field-${f.key}`}>
            <Label htmlFor={id}>{label}</Label>
            {f.type === 'LISTA' ? (
              <Select id={id} value={value} onChange={(e) => onChange(f.key, e.target.value)}>
                <option value="">—</option>
                {f.options.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </Select>
            ) : f.type === 'SI_NO' ? (
              <Select id={id} value={value} onChange={(e) => onChange(f.key, e.target.value)}>
                <option value="">—</option>
                <option value="true">Sí</option>
                <option value="false">No</option>
              </Select>
            ) : (
              <Input
                id={id}
                type={f.type === 'NUMERO' ? 'number' : f.type === 'FECHA' ? 'date' : 'text'}
                step={f.type === 'NUMERO' ? 'any' : undefined}
                maxLength={f.type === 'TEXTO' ? 300 : undefined}
                value={value}
                onChange={(e) => onChange(f.key, e.target.value)}
              />
            )}
            {errors?.[f.key] && <p className="text-destructive text-xs">{errors[f.key]}</p>}
          </div>
        );
      })}
    </>
  );
}
